"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var window_factory_1 = require("../../module/browser/window.factory");
var browserWindowService = window_factory_1.BrowserWindowFactory();
function WindowService() {
    return browserWindowService;
}
exports.WindowService = WindowService;
//# sourceMappingURL=service.js.map